import { getLocalStorageInfo } from "../../console_management/utils_v2"
import config from '../../config';

export const leaseStatus = {
    jacLeaseStatus: [{ label: 'Prospect', value: '11' }, { label: 'In Storage', value: '10' }, { label: 'Lease Return', value: '9' }, { label: 'MOU Signed', value: '8' }, { label: 'MOU Issued', value: '7' }, { label: 'Lease Issued', value: '6' }, { label: 'Archive', value: '5' }, { label: 'Written Off/ Sold / Part out', value: '4' },
    { label: 'Off Lease', value: '2' }, { label: 'On Lease', value: '1' },],
    defaultLeaseStatus: [{ label: 'Archive', value: '5' }, { label: 'On Lease', value: '1' }, { label: 'Off Lease', value: '2' }, { label: 'On Ground', value: '3' }, { label: 'Written Off/ Sold / Part out', value: '4' },],
    airAsiaLeaseStatus: [{ label: 'Prospect', value: '11' }]
}
export const revisionItemList = [
    { content_type: 'amaogandincidents', value: 'AOG and Incidents' },
    { content_type: 'amaircraft', value: 'Aircraft' },
    { content_type: 'amengine', value: 'Engine' },
    { content_type: 'amapu', value: 'APU' },
    { content_type: 'ampropeller', value: 'Propeller' },
    { content_type: 'amlandinggear', value: 'Landing Gear' },
    { content_type: 'amavionics', value: 'Avionics' },
    { content_type: 'amcrewseating', value: 'Crew Seat' },
    { content_type: 'amlavatory', value: 'Lavatory' },
    { content_type: 'ampassengerseating', value: 'Passenger Cabin' },
    { content_type: 'amgalley', value: 'Galley' },
    { content_type: 'amcabinequipments', value: 'Equipment' },
    { content_type: 'amlopahistory', value: 'LOPA' },
    { content_type: 'amstcmods', value: 'STCs & Mods' },
    { content_type: 'amremarks', value: 'Additional Remarks' },
]
export const revisionInItem = {
     'amaogandincidents': 'AOG and Incidents' ,
     'amaircraft': 'Aircraft' ,
     'amengine': 'Engine' ,
     'amapu': 'APU' ,
     'ampropeller': 'Propeller' ,
     'amlandinggear': 'Landing Gear' ,
     'amavionics': 'Avionics' ,
     'amcrewseating': 'Crew Seat' ,
     'amlavatory': 'Lavatory' ,
     'ampassengerseating': 'Passenger Cabin' ,
     'amgalley': 'Galley' ,
     'amcabinequipments': 'Equipment' ,
     'amlopahistory': 'LOPA' ,
     'amstcmods': 'STCs & Mods' ,
     'amremarks': 'Additional Remarks',
     'amutilization' : 'Custom Utilization',
     'amcomponent' : 'Component',
     'amenginelimitedlifepart' : 'Primary LLP',
     'amenginelimitedlifepartsecondary' : 'Secondary LLP',
     "amarchivedreports" : "Archived Tech Specs",
     "amassetnonllp" : "Non LLP"
}
export const castleAirInstance = [479,472].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const halcyonInstance = [484].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const jetStreamInstance =  [442,463].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const smbcInstance = [465].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const lessorCheckInstance =  [406].includes(getLocalStorageInfo()?.defaultLessor?.id) ;
export const titanAviInstance =  getLocalStorageInfo()?.defaultLessor?.id === 480;
export const gaTelesisInstance = [498].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const hanwahaInstance = [483].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const avationPlcInstance =  [504].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const leshaBankInstance = [510].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const regionalOneInstance = [242].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const mtInstance = [519].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const wngCapitalInstance =  getLocalStorageInfo()?.defaultLessor?.id === 213;
export const testLessor = getLocalStorageInfo()?.defaultLessor?.id === 13;
export const acuCamoInstance = getLocalStorageInfo()?.defaultLessor?.id === 409;
export const spartaLease = getLocalStorageInfo()?.defaultLessor?.id === 321;